import { CommonMap } from 'client/tracking/maps/common';
import { TrackingEvent } from 'client/tracking/event';
import { TrackingConstant } from 'client/tracking/constant';

const map = {
  view_sign_up: TrackingEvent.actionStart(TrackingConstant.ACTION_SIGN_UP, TrackingConstant.BEGIN_SIGN_UP, {
    action_cause: 'page_load',
    value: 'insider_sign_up',
    creativeId: 'edm-entry-insider-sign-up',
  }),
};

export const TrackingMap = {
  ...CommonMap,
  ...map,
};
